<template>
  <v-layout wrap>
    <v-flex xs12 class="mb-3">
      <v-sheet height="auto">
        <CalendarLoadingIcons :loading-events="loadingEvents" :loading-documents="loadingDocuments"
                              :loading-presentations="loadingPresentations"></CalendarLoadingIcons>
        <v-calendar v-model="date" locale="es-ar" ref="calendar" color="primary" class="custom-font-regular">
          <template slot="day" slot-scope="{ date }">
            <template v-for="event in eventsMap[date]">
              <CalendarEventElement v-if="event.status === availableEventStatus" :hide="hideDetails" :event="event" :key="event.pk"></CalendarEventElement>
            </template>
            <template v-for="presentation in presentationsMap[date]">
              <CalendarPresentationElement :hide="hideDetails" :presentation="presentation"
                                           :key="presentation.pk"></CalendarPresentationElement>
            </template>
            <template v-for="document in documentsMap[date]">
              <CalendarDocumentElement :hide="hideDetails" :document="document"
                                       :key="document.pk"></CalendarDocumentElement>
            </template>
          </template>
        </v-calendar>
      </v-sheet>
    </v-flex>
    <v-flex sm4 xs12 class="text-sm-left text-xs-center">
        <v-btn @click="previousDay">
        <v-icon dark left>keyboard_arrow_left</v-icon>
        Anterior
      </v-btn>
    </v-flex>
    <v-flex sm4 xs12 class="text-xs-center" pt-2>
      <h2 class="custom-font-semi-bold">{{ formattedDate }}</h2>
    </v-flex>
    <v-flex sm4 xs12 class="text-sm-right text-xs-center">
      <v-btn @click="nextDay">Siguiente
        <v-icon right dark>keyboard_arrow_right</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import CalendarEventElement from './CalendarEventElement'
import CalendarDocumentElement from './CalendarDocumentElement'
import CalendarPresentationElement from './CalendarPresentationElement'
import CalendarLoadingIcons from './CalendarLoadingIcons'

const YEAR_INDEX = 0
const MONTH_INDEX = 1
const MONTHS = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

export default {
  props: {
    value: Boolean,
    delay: Promise
  },
  components: {
    CalendarEventElement,
    CalendarDocumentElement,
    CalendarPresentationElement,
    CalendarLoadingIcons
  },

  data () {
    return {
      loadingEvents: false,
      loadingDocuments: false,
      loadingPresentations: false,
      date: null,
      events: [],
      documents: [],
      presentations: [],
      availableEventStatus: 1
    }
  },

  computed: {
    ...mapGetters(['isClubRole']),
    hideDetails: {
      set (value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    },
    eventsMap () {
      return this.mapList(this.events, 'date')
    },
    presentationsMap () {
      return this.mapList(this.presentations, 'fechaVencimiento')
    },
    documentsMap () {
      return this.mapList(this.documents, 'date')
    },
    month () {
      return (this.date) ? this.date.split('-')[MONTH_INDEX] : ''
    },
    year () {
      return (this.date) ? this.date.split('-')[YEAR_INDEX] : ''
    },
    formattedDate () {
      return (this.month) ? `${MONTHS[parseInt(this.month)]} de ${this.year}` : ''
    }
  },

  methods: {
    setInitialDate () {
      let today = new Date()
      this.date = `${today.getFullYear()}-${today.getMonth() + 1}-1}`
    },
    previousDay () {
      this.hideDetails = true
      this.delay.then(() => {
        this.$refs.calendar.prev()
        this.fetchData()
        this.hideDetails = false
      })
    },
    nextDay () {
      this.hideDetails = true
      this.delay.then(() => {
        this.$refs.calendar.next()
        this.fetchData()
        this.hideDetails = false
      })
    },
    mapList (list, property) {
      return list.reduce((acc, obj) => {
        let key = obj[property]
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(obj)
        return acc
      }, {})
    },
    createDocumentFromResponse (document) {
      const [day, month, year] = document.date.split('/')
      return {
        title: document.criterion,
        subarea: document.subarea,
        subareaId: document.subareaId,
        statusDisplay: document.statusDisplay,
        date: year + '-' + month + '-' + day,
        open: false,
        pk: document.pk
      }
    },
    createEventFromResponse (event) {
      return {
        status: event.status,
        title: event.title,
        location: event.ubicacion,
        details: event.description,
        date: event.year + '-' + event.month + '-' + event.day,
        open: false,
        pk: event.pk
      }
    },
    fetchEvents () {
      this.loadingEvents = true
      this.axios
        .get(`/events?month=${this.month}&year=${this.year}`)
        .then((response) => {
          this.loadingEvents = false
          this.events = response.data.results.map(e => this.createEventFromResponse(e))
        })
        .catch(error => {
          this.loadingEvents = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchDocuments () {
      this.loadingDocuments = true
      this.axios
        .get(`calendar/documentation?month=${this.month}&year=${this.year}`)
        .then((response) => {
          this.loadingDocuments = false
          this.documents = response.data.map(e => this.createDocumentFromResponse(e))
        })
        .catch(error => {
          this.loadingDocuments = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchPresentations () {
      this.loadingPresentations = true
      this.axios
        .get(`calendar/presentations?month=${this.month}&year=${this.year}`)
        .then((response) => {
          this.loadingPresentations = false
          this.presentations = response.data
        })
        .catch(error => {
          this.loadingPresentations = false
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchData () {
      // this.fetchEvents()
      if (this.isClubRole) {
        if (this.$store.state.permissions.canViewVencimientos) {
          this.fetchDocuments()
        }
        if (this.$store.state.permissions.canViewPresentaciones) {
          this.fetchPresentations()
        }
      }
    }
  },

  mounted () {
    this.setInitialDate()
    this.fetchData()
  },

  watch: {
    '$store.state.permissions.canViewVencimientos' () {
      if (this.$store.state.permissions.canViewVencimientos) {
        this.fetchDocuments()
      }
    },
    '$store.state.permissions.canViewPresentaciones' () {
      if (this.$store.state.permissions.canViewPresentaciones) {
        this.fetchPresentations()
      }
    }
  }
}
</script>
